import React from 'react';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import SelectField from 'components/pure/utils/form/SelectField';

// Order here mirrors strengths & weaknesses dropdown.
const options = [
  {label: 'Manager', value: 'MY_SCORES'},
  {label: 'Self', value: 'REP_SELF_SCORES'},
  {label: 'Team', value: 'TEAM_SCORES'},
  {label: 'All except self reviews', value: 'ALL_SCORES'},
];

export default class RepProfileSkillsScoredBySelector extends React.PureComponent {
  render() {
    return (
      <div className="rep-profile-scored-by-container">
        <FieldContainer label="Scored By" className="scored-by-selector-item">
          <SelectField
            className="scored-by-selector"
            options={options}
            onChange={this.props.onSelectScoredByType}
            hideResetButton={true}
            value={this.props.value}
          />
        </FieldContainer>
      </div>
    );
  }
}
